module.exports = __webpack_public_path__ + "static/media/designer.bd5e6c71.svg";